import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  EntityApi,
  EntityDiaryApi,
  FilterEntityDiaryOptions,
  FindEntityDiaryByEntitySectionOptions,
} from 'api';

export const filterEntityDiary = createAsyncThunk<
  any,
  FilterEntityDiaryOptions,
  { rejectValue: { message: string } }
>('entityDiary/findEntityDiary', async (options, { rejectWithValue }) => {
  try {
    return await EntityDiaryApi.filter(options);
  } catch (error: any) {
    if (!error.response) {
      throw error;
    }

    return rejectWithValue(error.response.data);
  }
});

export const verifyEntityDiary = createAsyncThunk(
  'entityDiary/verifyEntityDiary',
  async (option: any, { rejectWithValue }) => {
    try {
      return await EntityApi.verifyDiary();
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityDiary = createAsyncThunk(
  'entityDiary/findOneEntityDiary',
  async (params: { id: string }, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityDiaryApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityDiary = createAsyncThunk(
  'entityDiary/updateEntityDiary',
  async (params: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityDiaryApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityDiary = createAsyncThunk(
  'diary/createEntityDiary',
  async (body: any = {}, { rejectWithValue }) => {
    try {
      const response = await EntityDiaryApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityDiaryByEntitySection = createAsyncThunk(
  'diary/findEntityDiaryByEntitySection',
  async (
    params: {
      entitySectionID: string;
      options: FindEntityDiaryByEntitySectionOptions;
    },
    { rejectWithValue }
  ) => {
    try {
      const { entitySectionID, options } = params;
      const response = await EntityDiaryApi.findEntityDiaryByEntitySection(
        entitySectionID,
        options
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityDiary = createAsyncThunk(
  'diary/removeEntityDiary',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityDiaryApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const entityDiarySlice = createSlice({
  name: 'entityDiary',
  initialState: {
    tableList: [],
    list: [],
  },
  reducers: {},
  extraReducers: {},
});

const { reducer: diaryReducer } = entityDiarySlice;

export default diaryReducer;
